import s from './DatasetSelector.module.scss';

const DatasetSelector = ({
    datasets,
    selectedDataset,
    loadingDatasets,
    onDatasetChange,
    datasetsError,
}) => {
    return (
        <div className={s.Root}>
            <div className={s.Field}>
                <label className={s.Label}>Dataset</label>
                {datasetsError ? (
                    <div className={s.Error}>{datasetsError}</div>
                ) : (
                    <select
                        className={s.Select}
                        value={selectedDataset}
                        onChange={(e) => onDatasetChange(e.target.value)}
                        disabled={loadingDatasets}>
                        <option value="">
                            {loadingDatasets
                                ? 'Loading...'
                                : 'Select a dataset'}
                        </option>
                        {datasets.map((dataset) => (
                            <option key={dataset} value={dataset}>
                                {dataset}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    );
};

export default DatasetSelector;
